import type {ICountryConfiguration} from './types'

import {Feature} from '../types'

const US: ICountryConfiguration = {
    [Feature.Mileage]: {
        canUseMileage: false,
    },
}

export default US
